import {  make } from 'vuex-pathify';


export const state = {
  systemMessageOptions: {
   systemMessage: "",
   systemBarColor: "primary",
  
  }
};

export const mutations = {
  ...make.mutations(state)
};

export const getters = {
  ...make.getters(state)
};

export const actions = {

  async showSystemMessage({ commit }, { message, color}) {
    commit('SET_SYSTEM_MESSAGE_OPTIONS', {
      systemMessage: message,
      systemBarColor: color
    });
  },

  async clearSystemMessage({ commit }) {
    commit('SET_SYSTEM_MESSAGE_OPTIONS', {
      systemMessage: "",
      systemBarColor: "primary",
    });
  },
};
